import styled, { css } from 'styled-components';
import { colorVariables, mediaTemplates, fontVariables } from 'theme/variables';
import { Icon, Text } from 'components';

export const PosterStyled = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  text-decoration: none;
  background-color: white;
  overflow: hidden;
  flex-grow: 1;
`;

export const StyledImg = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  height: 100%;
  position: relative;
  background-size: cover;
  background-position: center;
  flex-grow: 1;
  z-index: 3;
`;

export const BackLayoutWrap = styled.div`
  ${(props) =>
    props.type === 'subscriptionPoster'
      ? css`
          position: absolute;
          display: flex;
          flex-direction: column;
          right: 0;
          top: calc(100% / 6);
          height: calc((100% / 3 * 2) + 1.92%);
          width: calc((100% / 3 * 2) + 2.75%);
          flex-grow: 1;
          z-index: 1;
        `
      : css`
          position: relative;
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 100%;
          background-color: ${colorVariables.white_lightgainsboro};
          flex-grow: 1;
        `};
`;

export const SubscriptionWrapper = styled.div`
  font-size: 0;
  height: 100%;
`;

export const SubscriptionImgWrap = styled.div`
  position: absolute;
  background: ${colorVariables.white_lightgainsboro};
  height: calc(100% / 3);
  width: calc(100% / 3);
  z-index: 1;

  &:nth-child(1) {
    top: calc(-1 * ((100% / 6) + 1.92%));
    right: calc((100% / 3 * 2) + 5.5%);
  }

  &:nth-child(2) {
    top: calc(-1 * ((100% / 6) + 1.92%));
    right: calc((100% / 3) + 2.75%);
  }

  &:nth-child(3) {
    top: calc(-1 * ((100% / 6) + 1.92%));
    right: 0;
  }

  &:nth-child(4) {
    top: calc(100% / 6);
    right: calc((100% / 3 * 2) + 5.5%);
  }

  &:nth-child(5) {
    top: calc((100% / 6 * 3) + 1.92%);
    right: calc((100% / 3 * 2) + 5.5%);
  }

  &:nth-child(6) {
    top: calc((100% / 6 * 5) + 3.84%);
    right: calc((100% / 3 * 2) + 5.5%);
  }

  &:nth-child(7) {
    top: calc((100% / 6 * 5) + 3.84%);
    right: calc((100% / 3) + 2.75%);
  }

  &:nth-child(8) {
    top: calc((100% / 6 * 5) + 3.84%);
    right: 0;
  }
`;

export const SubscriptionImg = styled.div`
  display: block;
  max-width: 100%;
  height: 100%;
  position: relative;
  background-size: cover;
  background-position: center;
  z-index: 3;
`;

export const Trailer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.235s ease-in, visibility 0.235s ease-in;
  z-index: 3;

  &:hover {
    opacity: 1;
    transition: opacity 0.235s ease-out;
  }
`;

export const StyledIcon = styled(Icon)`
  position: relative;
  margin-bottom: 8px;
  margin-top: 40px;
  ${mediaTemplates.l} {
    margin-bottom: 10px;
  }
`;

export const StyledText = styled(Text)`
  position: relative;
  text-align: center;
  line-height: 15px;
  font-size: ${fontVariables.fs_xs};

  ${mediaTemplates.l} {
    font-size: ${fontVariables.fs_s};
  }
`;

export const PlaceholderIcon = styled.svg`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;
